/**
 * "Is this your pickup spot?" check that runs when the rider taps Book.
 * Pure functions so the rules can be unit-tested.
 *
 * A pickup that came from GPS was never looked at by the rider, and indoor GPS
 * can be 50 m+ off, so the Anna drives to the wrong lane. Before booking we show
 * that pickup on the pin map once. A pickup the rider chose themselves (pin,
 * search, saved place, rebook) skips the check.
 */

/** Moving the pin further than this re-prices the trip before booking. */
export const PICKUP_CHECK_MOVE_M = 25;

/** Only a GPS pickup gets the check; any other source was chosen by the rider. */
export const pickupNeedsCheck = (pickup) => Boolean(pickup?.lat) && pickup.source === 'gps';

/**
 * What "Confirm" does on the check screen.
 *   'book'    - pin kept (or nudged a few metres): book now on the fare shown.
 *   'requote' - pin moved: back to the fare card so the rider sees the new fare.
 */
export const pickupCheckOutcome = (movedM) =>
  (Number.isFinite(movedM) && movedM <= PICKUP_CHECK_MOVE_M ? 'book' : 'requote');
